<script lang="ts" setup>
import basket from '@/assets/icons/pro-calculate-footer/basket.svg'
import declaration from 'assets/icons/pro-calculate/auction.svg'
import money from '@/assets/icons/pro-calculate-footer/money.svg'
import report from '@/assets/icons/pro-calculate-footer/report.svg'
import usa from '@/assets/icons/pro-calculate-footer/usa.svg'

const { t } = useLang()

const promotions = computed(() => [
  {
    icon: usa,
    transKey: t('pro_calculation.footer-1'),
  },
  {
    icon: report,
    transKey: t('pro_calculation.footer-2'),
  },
  {
    icon: declaration,
    transKey: t('pro_calculation.footer-3'),
  },
  {
    icon: money,
    transKey: t('pro_calculation.footer-4'),
  },
  {
    icon: basket,
    transKey: t('pro_calculation.footer-5'),
  },
])
</script>

<template>
  <section class="calculator-component px-3 lg:px-0">
    <Container>
      <div class="grid grid-cols-2 gap-1 md:gap-5 lg:grid-cols-5 lg:gap-10 max-w-2xlg xl:m-auto">
        <div v-for="(promotion, index) in promotions" :key="index" class="registration-benefits flex-col md:flex-row">
          <div class="benefit-icon">
            <div class="icon">
              <img :src="promotion.icon" :alt="promotion.transKey" class="dark:invert" />
            </div>
          </div>
          <div class="text">
            <p class="benefit-heading contents">{{ promotion.transKey }}</p>
          </div>
        </div>
      </div>
    </Container>
  </section>
</template>

<style lang="postcss" scoped>
.calculator-component {
  @apply bg-neutral6 dark:bg-dmGray2 py-10;
}
.registration-benefits {
  @apply flex gap-0 md:gap-3 items-center;
  .benefit-icon {
    .icon {
      @apply flex w-14 h-14 items-center justify-center rounded-full;
    }
  }
  .text {
    @apply text-center lg:text-left;
  }
  .benefit-heading {
    @apply text-text2 dark:text-dmText1 text-sm lg:text-lg min-h-[3.5rem] font-bold;
  }
}
</style>

<style lang="postcss" scoped>
.wl {
  .calculator-component {
    @apply bg-brand-footer;
  }
}
</style>
